<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import mercadoLivreClient from 'dashboard/api/channel/mercadoLivreClient';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();

const SITES = [
  { id: 'MLB', label: 'Brasil' },
  { id: 'MLA', label: 'Argentina' },
  { id: 'MLM', label: 'México' },
  { id: 'MLC', label: 'Chile' },
  { id: 'MCO', label: 'Colômbia' },
  { id: 'MLU', label: 'Uruguai' },
];

const selectedSite = ref('MLB');
const hasError = ref(false);
const errorStateMessage = ref('');
const errorStateDescription = ref('');
const isRequestingAuthorization = ref(false);

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const errorCode = urlParams.get('code');
  const errorMessage = urlParams.get('error_message');

  if (errorMessage) {
    hasError.value = true;
    if (errorCode === '400') {
      errorStateMessage.value = errorMessage;
      errorStateDescription.value = t(
        'INBOX_MGMT.ADD.MERCADO_LIVRE.ERROR_AUTH'
      );
    } else {
      errorStateMessage.value = t('INBOX_MGMT.ADD.MERCADO_LIVRE.ERROR_MESSAGE');
      errorStateDescription.value = errorMessage;
    }
  }
  const cleanURL = window.location.pathname;
  window.history.replaceState({}, document.title, cleanURL);
});

const requestAuthorization = async () => {
  isRequestingAuthorization.value = true;
  try {
    const response = await mercadoLivreClient.generateAuthorization({
      site_id: selectedSite.value,
    });
    const {
      data: { url },
    } = response;
    window.location.href = url;
  } catch (error) {
    isRequestingAuthorization.value = false;
    hasError.value = true;
    errorStateMessage.value = t('INBOX_MGMT.ADD.MERCADO_LIVRE.ERROR_MESSAGE');
    errorStateDescription.value = t('INBOX_MGMT.ADD.MERCADO_LIVRE.ERROR_AUTH');
  }
};
</script>

<template>
  <div class="h-full p-6 w-full max-w-full flex-shrink-0 flex-grow-0">
    <div class="flex flex-col items-center justify-start h-full text-center">
      <div v-if="hasError" class="max-w-lg mx-auto text-center">
        <h5>{{ errorStateMessage }}</h5>
        <p v-if="errorStateDescription">
          {{ errorStateDescription }}
        </p>
      </div>
      <div
        v-else
        class="flex flex-col items-center justify-center px-8 py-10 text-center rounded-2xl outline outline-1 outline-n-weak"
      >
        <h6 class="text-2xl font-medium">
          {{ $t('INBOX_MGMT.ADD.MERCADO_LIVRE.CONNECT_TITLE') }}
        </h6>
        <p class="py-6 text-sm text-n-slate-11">
          {{ $t('INBOX_MGMT.ADD.MERCADO_LIVRE.HELP') }}
        </p>
        <label class="w-full max-w-xs text-left mb-4">
          <span class="text-sm font-medium text-n-slate-12">
            {{ $t('INBOX_MGMT.ADD.MERCADO_LIVRE.SITE_LABEL') }}
          </span>
          <select
            v-model="selectedSite"
            class="mt-1.5 w-full rounded-lg border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12"
          >
            <option v-for="site in SITES" :key="site.id" :value="site.id">
              {{ site.label }}
            </option>
          </select>
        </label>
        <Button
          class="!rounded-full !px-6 bg-[#FFE600] text-[#2D3277] hover:opacity-90"
          lg
          icon="i-lucide-shopping-bag"
          :disabled="isRequestingAuthorization"
          :is-loading="isRequestingAuthorization"
          :label="$t('INBOX_MGMT.ADD.MERCADO_LIVRE.CONNECT_BUTTON')"
          @click="requestAuthorization()"
        />
      </div>
    </div>
  </div>
</template>
